import type { OnInit } from '@angular/core';
import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import type { BehaviorSubject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'invd-smbs-exchange-expandable',
  templateUrl: './smbs-exchange-expandable.component.html',
  styleUrls: ['./smbs-exchange-expandable.component.scss'],
})
export class SmbsExchangeExpandableComponent implements OnInit {
  public dealNumberOrCusip = '830';

  public expdleSmbsExchangeResponse: any;

  private route = inject(ActivatedRoute);

  ngOnInit() {
    this.expdleSmbsExchangeResponse = (this.route.data as BehaviorSubject<any>).value;
  }
}
